import React, { useEffect, useState } from 'react';
import { BookOpen, X } from 'lucide-react';
import { svcListArticles } from '@/services/entitiesService';

export default function FinanceEducation() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => { svcListArticles().then(setItems).catch(() => setItems([])); }, []);

  const published = items.filter((a) => a.published !== false);
  if (published.length === 0) return null;

  return (
    <section className="my-12" data-testid="finance-education">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-6">
          <span className="inline-flex items-center gap-1 text-xs font-bold text-[#1B2A4A] bg-yellow-100 px-2 py-1 rounded-full uppercase"><BookOpen size={12} /> Educación financiera</span>
          <h3 className="text-2xl md:text-3xl font-extrabold text-[#1B2A4A] mt-2">Aprende a manejar tu dinero</h3>
          <p className="text-sm text-slate-500">Tips y guías cortas para vivir mejor con lo que ganas.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {published.slice(0, 6).map((a) => (
            <button key={a.id} onClick={() => setOpen(a)} data-testid={`article-${a.id}`} className="text-left bg-white rounded-2xl border overflow-hidden hover:shadow-md transition group">
              {a.image ? (
                <div className="aspect-[16/9] overflow-hidden bg-slate-100"><img src={a.image} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" loading="lazy" /></div>
              ) : (
                <div className="aspect-[16/9] bg-gradient-to-br from-[#F8D13F] to-yellow-200 flex items-center justify-center"><BookOpen size={40} className="text-[#1B2A4A]" /></div>
              )}
              <div className="p-4">
                {a.tag && <span className="text-[10px] font-bold uppercase text-yellow-700">{a.tag}</span>}
                <h4 className="font-extrabold text-[#1B2A4A] mt-1 line-clamp-2">{a.title}</h4>
                <p className="text-xs text-slate-500 mt-1 line-clamp-3">{a.body}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            {open.image && <img loading="lazy" decoding="async" src={open.image} alt={open.title} className="w-full aspect-[16/9] object-cover rounded-t-2xl" />}
            <div className="p-6">
              <div className="flex justify-between items-start gap-4 mb-3">
                <div>
                  {open.tag && <span className="text-[10px] font-bold uppercase text-yellow-700">{open.tag}</span>}
                  <h4 className="font-extrabold text-[#1B2A4A] text-xl mt-1">{open.title}</h4>
                </div>
                <button onClick={() => setOpen(null)} className="text-slate-500 hover:text-slate-900"><X size={20} /></button>
              </div>
              <div className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">{open.body}</div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
